module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"caption":"Tips: Update the way of viewing your monitored site site.","action":"LET\u0027S PROCEED"},"it":{"caption":"Consigli: Aggiorna la modalità di visualizzazione del sito monitorato.","action":"PROCEDIAMO"}}')
  delete Component.options._Ctor
}
